import { FacebookIcon, InstagramIcon } from './icons';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <a href="#sakums" className="site-footer__brand">
          Salons Siluets
        </a>

        <nav className="site-footer__nav" aria-label="Kājenes navigācija">
          <a href="#davanu-karte">Dāvanu karte</a>
          <a href="#masazas">Masāžas</a>
          <a href="#proceduras">Procedūras</a>
          <a href="#kontakti">Kontakti</a>
        </nav>

        <div className="site-footer__socials">
          <a
            href="https://www.facebook.com/WELLSIMCENTRSCESIS"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FacebookIcon />
          </a>
          <a
            href="https://www.instagram.com/aiva_parandjuka/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramIcon />
          </a>
        </div>
      </div>

      <div className="container site-footer__base">
        <span>© {year} Salons Siluets</span>
        <span>Skaistumkopšana &amp; labsajūta</span>
      </div>
    </footer>
  );
}
